import { render } from "./comboSubAnyMultiSubOption.vue?vue&type=template&id=2479d588&scoped=true"
import script from "./comboSubAnyMultiSubOption.vue?vue&type=script&lang=js"
export * from "./comboSubAnyMultiSubOption.vue?vue&type=script&lang=js"

import "./comboSubAnyMultiSubOption.vue?vue&type=style&index=0&id=2479d588&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2479d588"]])

export default __exports__